import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import LinkButton from 'flarum/common/components/LinkButton';
import Button from 'flarum/common/components/Button';
import MobileTabSessionDropdown from './MobileTabSessionDropdown';
export default class MobileTab extends Component {
  view(vnode) {
    return m("nav", {
      className: "MobileTab"
    }, m("ul", {
      className: "MobileTab-items"
    }, listItems(this.items().toArray())));
  }
  items() {
    const items = new ItemList();
    items.add('home', m(LinkButton, {
      href: "/",
      icon: "fas fa-home"
    }, app.translator.trans('acpl-mobile-tab.forum.home')), 100);
    if (app.routes.index.path === '/all') {
      items.add('all', m(LinkButton, {
        href: app.route('index'),
        icon: "fas fa-comments"
      }, app.translator.trans('acpl-mobile-tab.forum.all_discussions')), 90);
    } else if ('askvortsov-categories' in flarum.extensions) {
      items.add('categories', m(LinkButton, {
        href: app.route('categories'),
        icon: "fas fa-th-list"
      }, app.translator.trans('acpl-mobile-tab.forum.categories')), 90);
    } else if ('flarum-tags' in flarum.extensions) {
      items.add('tags', m(LinkButton, {
        href: app.route('tags'),
        icon: "fas fa-tags"
      }, app.translator.trans('acpl-mobile-tab.forum.tags')), 90);
    }
    if (app.session.user) {
      const unread = app.session.user.unreadNotificationCount();
      // The default Flarum component opens as a dropdown on mobile if the drawer is not open
      items.add('notifications', m(LinkButton, {
        href: app.route('notifications'),
        icon: "fas fa-bell",
        title: app.translator.trans('acpl-mobile-tab.forum.notifications')
      }, unread ? m("span", {
        className: "Bubble"
      }, unread) : '', app.translator.trans('acpl-mobile-tab.forum.notifications')), 80);
      items.add('session', m(MobileTabSessionDropdown, null), 70);
    } else {
      items.add('logIn', m(Button, {
        icon: "fas fa-user",
        className: "Button Button--link",
        onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
      }, app.translator.trans('acpl-mobile-tab.forum.log_in')), 70);
    }
    return items;
  }
}
flarum.reg.add('acpl-mobile-tab', 'forum/components/MobileTab', MobileTab);